import { render, staticRenderFns } from "./operateArea.vue?vue&type=template&id=6d480364"
import script from "./operateArea.vue?vue&type=script&lang=js"
export * from "./operateArea.vue?vue&type=script&lang=js"
import style0 from "./operateArea.vue?vue&type=style&index=0&id=6d480364&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports